export default "__VITE_ASSET__CebnLvUa__"